import React from "react";
import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import styles from "../../styles/pages/user/managerdashboard/manager-dashboard-inquiringvdo.module.scss";
import IconView from "../../public/assets/images/icon-view.svg";
import { Link } from "react-router-dom";
import roundRing from "../../public/assets/images/round-ring.svg";
import iconOops from "../../public/assets/images/icon-smile.svg";
import FilterNoResultIcon from "../../ui/Icons/FilterNoResultIcon";
import ApiLoader from "../Loaders/ApiLoader";
import {
    getAbsoluteImageURI,
    getUtcDate,
    getUtcTime,
} from "../../lib/functions/utils.lib";
import Pagination from "../UtilitiesComponent/Pagination";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";
import { useState } from "react";

export default function ManagerInquiringVideoTable({
    managerVideos,
    managerVideosIsSuccess,
    managerVideosIsLoading,
    handlePageChange,
    filterParams,
    calanderDate,
    resetFilterparams,
}) {
    const [openModal, setOpenModal] = useState(false);
    const [openModalTwo, setOpenModalTwo] = useState(false);
    const [id, setId] = useState();

    const onOpen = (id) => {
        setId(id);
        setOpenModal(true);
    };
    const onClose = () => {
        setId();
        setOpenModal(false);
        // handleTriggreFetch();
    };
    const onOpenTwo = (id) => {
        setId(id);
        setOpenModalTwo(true);
    };
    const onCloseTwo = () => {
        setId();
        setOpenModalTwo(false);
    };
    return (
        <>
            <ApiLoader
                loading={
                    managerVideosIsLoading &&
                    !(
                        managerVideosIsSuccess ||
                        managerVideos?.data?.data?.length ||
                        filterParams !== null ||
                        calanderDate.from ||
                        calanderDate.to
                    )
                }
            />
            <Box className={styles.pendingTableWrap}>
                <TableContainer>
                    <Table className={styles.pendingVdotable} stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className={styles.thPendingVsid}>
                                    VSID
                                </TableCell>
                                <TableCell
                                    className={styles.thPendingAcquisitor}
                                >
                                    Acquisitor
                                </TableCell>
                                <TableCell
                                    className={styles.thPendingThumbnail}
                                >
                                    Thumbnail
                                </TableCell>
                                <TableCell className={styles.thPendingTitle}>
                                    Title
                                </TableCell>
                                <TableCell
                                    className={styles.thPendingSubmitterName}
                                >
                                    Submitter Name
                                </TableCell>
                                <TableCell className={styles.thPendingEmail}>
                                    Email Address
                                </TableCell>
                                <TableCell
                                    className={styles.thPendingSubmissionDate}
                                >
                                    Submission Date
                                </TableCell>
                                <TableCell
                                    className={styles.thPendingInquiringDate}
                                >
                                    Inquiring Since
                                </TableCell>
                                <TableCell
                                    className={styles.thPendingView}
                                    align="center"
                                >
                                    View
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        {managerVideosIsLoading &&
                            !(
                                managerVideosIsSuccess ||
                                managerVideos?.data?.data?.length ||
                                filterParams !== null ||
                                calanderDate.from ||
                                calanderDate.to
                            ) ? (
                            ""
                        ) : managerVideos?.data?.data?.length ? (
                            <TableBody>
                                {managerVideos?.data?.data?.map(
                                    (row, index) => (
                                        <>
                                            <TableRow
                                                key={index}
                                                sx={{ position: "relative" }}
                                            >
                                                <TableCell
                                                    scope="row"
                                                    className={
                                                        styles.thPendingVsid
                                                    }
                                                >
                                                    <Typography variant="body2">
                                                        {row?.vsid}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingAcquisitor
                                                    }
                                                >
                                                    <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                                                        {row?.buyer
                                                            ? `${row?.buyer.name} ${row?.buyer.last_name}`
                                                            : "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingThumbnail
                                                    }
                                                >
                                                    <img
                                                        onClick={() =>
                                                            onOpenTwo(row?.id)
                                                        }
                                                        src={getAbsoluteImageURI(
                                                            row?.thumbnail
                                                        )}
                                                        width={73}
                                                        height={46}
                                                        alt="image"
                                                        className={
                                                            styles.thumImg
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingTitle
                                                    }
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        className={
                                                            styles.tableTitle
                                                        }
                                                    >
                                                        {row?.title
                                                            ? row?.title
                                                            : "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingSubmitterName
                                                    }
                                                >
                                                    <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                                                        {`${row?.first_name} ${row?.last_name}`}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingEmail
                                                    }
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        className={
                                                            styles.emailTxt
                                                        }
                                                    >
                                                        {row?.email
                                                            ? row?.email
                                                            : "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingSubmissionDate
                                                    }
                                                >
                                                    <Typography variant="body2">
                                                        {getUtcDate(
                                                            row?.created_at
                                                        )}
                                                        <br />{" "}
                                                        {getUtcTime(
                                                            row?.created_at
                                                        )}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        styles.thPendingInquiringDate
                                                    }
                                                >
                                                    <Typography variant="body2">
                                                        {getUtcDate(
                                                            row?.status_changed_at
                                                        )}
                                                        <br />{" "}
                                                        {getUtcTime(
                                                            row?.status_changed_at
                                                        )}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className={
                                                        styles.thPendingView
                                                    }
                                                >
                                                    <Button
                                                        onClick={() =>
                                                            onOpen(row?.id)
                                                        }
                                                        className={
                                                            styles.StyledeyeIcon
                                                        }
                                                    >
                                                        <img
                                                            src={IconView}
                                                            width={16}
                                                            height={16}
                                                            alt="icon"
                                                        />
                                                    </Button>
                                                </TableCell>
                                                {row?.viewBy ? (
                                                    <>
                                                        <TableCell
                                                            className={
                                                                styles.tdOverlay
                                                            }
                                                        >
                                                            <p>
                                                                Submission is
                                                                currently being
                                                                viewed by
                                                                [MANAGER NAME]
                                                            </p>
                                                        </TableCell>
                                                    </>
                                                ) : null}
                                            </TableRow>
                                            <TableRow className={styles.blnkTd}>
                                                <TableCell colSpan={9}>
                                                    {""}
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )
                                )}
                                {managerVideos?.data?.data?.length &&
                                    managerVideos?.data.current_page &&
                                    managerVideos?.data.last_page ? (
                                    managerVideos?.data.current_page ===
                                        managerVideos?.data.last_page ? (
                                        <TableRow className={`${styles.endOfList} ${styles.nonHover}`}>
                                            <TableCell colSpan={9}>
                                                <Typography variant="body1">
                                                    End of list. We couldn't
                                                    find more videos under
                                                    inquiry matching your
                                                    selected filter(s).
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        ""
                                    )
                                ) : (
                                    ""
                                )}
                                <TableRow className={`${styles.paginationTble} ${styles.nonHover}`}>
                                    <TableCell
                                        colSpan={9}
                                        sx={{ border: "none !important" }}
                                    >
                                        {managerVideos?.data?.data?.length ? (
                                            <Pagination
                                                page={
                                                    managerVideos?.data
                                                        ?.current_page
                                                }
                                                lastpage={
                                                    managerVideos?.data
                                                        ?.last_page
                                                }
                                                onClick={handlePageChange}
                                                sendDataToParent={
                                                    handlePageChange
                                                }
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ) : filterParams !== null ? (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        className={`${styles.emptyFilterItem} ${styles.nonHover}`}
                                        colSpan={9}
                                    >
                                        <Box className={styles.filterNoResult}>
                                            <figure>
                                                <FilterNoResultIcon />
                                            </figure>
                                            <Typography variant="body1">
                                                We couldn’t find any matches for
                                                the selected filter(s).
                                            </Typography>
                                            <Button onClick={resetFilterparams}>
                                                Reset filters
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ) : calanderDate.from || calanderDate.to ? (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        className={`${styles.emptyDataItem} ${styles.dateRangeNoresult} ${styles.nonHover}`}
                                        colSpan={9}
                                    >
                                        <Box className={styles.noFilter}>
                                            <figure>
                                                <img
                                                    src={iconOops}
                                                    width={38}
                                                    height={41}
                                                    alt="icon"
                                                />
                                            </figure>
                                            <Typography variant="body1">
                                                We couldn't find any rejected
                                                submissions within the specified
                                                date range.
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ) : (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        className={`${styles.emptyDataItem}`}
                                        colSpan={9}
                                    >
                                        <Box className={styles.noFilter}>
                                            <figure>
                                                <img
                                                    src={roundRing}
                                                    width={207}
                                                    height={210}
                                                    alt="icon"
                                                />
                                            </figure>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    lineHeight:
                                                        "25px !important",
                                                }}
                                            >
                                                All clear! No videos under
                                                inquiry found.
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
            </Box>
            <VideoPageFullModal
                onClose={onClose}
                open={openModal}
                id={id}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="videoPageModal"
            />
            <WatchVideoModal
                onClose={onCloseTwo}
                open={openModalTwo}
                id={id}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="videoPageModal"
            />
        </>
    );
}
